/**
 * VP-175 — czysta logika budowania payloadu launchu z wizarda.
 *
 * Wydzielona z wizard-launch.ts (bez importów aplikacyjnych), żeby dało się ją
 * testować jednostkowo w Vitest (server-tests importują web-moduły relatywnie).
 */
export type WizardCreative = { url: string; type: "image" | "video"; name?: string };

export type WizardAdInput = {
  adAccountId: string;
  pageId: string;
  campaignName: string;
  linkUrl: string;
  /** Budżet dzienny w zł. */
  dailyBudget: number;
  headline: string;
  primaryText: string;
  creatives: WizardCreative[];
};

/**
 * Minimalny payload dla POST /api/campaign-creator/launch. Decyzje podjęte ZA
 * usera (idiotoodporność): cel = ruch na stronę (OUTCOME_TRAFFIC + LINK_CLICKS —
 * działa bez piksela i bez formularza leadowego), targetowanie = domyślne
 * szerokie (backend uzupełnia PL, 18–65), kampania startuje od razu — user
 * świadomie klika „Uruchom reklamę".
 */
export function buildWizardLaunchBody(input: WizardAdInput): Record<string, unknown> {
  const linkUrl = /^https?:\/\//i.test(input.linkUrl) ? input.linkUrl : `https://${input.linkUrl}`;
  return {
    adAccountId: input.adAccountId,
    pageId: input.pageId,
    campaignName: input.campaignName,
    objective: "OUTCOME_TRAFFIC",
    dailyBudget: input.dailyBudget,
    budgetType: "ABO",
    linkUrl,
    primaryTexts: [input.primaryText],
    headlines: [input.headline],
    description: "",
    callToAction: "LEARN_MORE",
    creatives: input.creatives,
    optimizationGoal: "LINK_CLICKS",
    billingEvent: "IMPRESSIONS",
    destinationType: "WEBSITE",
    activateImmediately: true,
  };
}
